import classNames from "classnames";
import type { FC } from "react";
import type { BookmarkTabsProps } from "./types";
import { AddTab } from "./AddTab";
import { Tab } from "./Tab";
import styles from "./styles.module.scss";

export const BookmarkTabs: FC<BookmarkTabsProps> = ({
  tabs,
  activeValue,
  addTabText,
  onChange,
  activeTabClassName,
  onAddClick,
  isAddable,
  isEditable,
  tabClassName,
  onCancelTab = () => "",
}) => {
  return (
    <div className={classNames(styles.container)}>
      {tabs.map((item, index) => (
        <Tab
          activeClassName={activeTabClassName}
          onCancelTab={() =>
            onCancelTab(tabs[index]?.value, tabs[index - 1]?.value, tabs[index + 1]?.value)
          }
          key={item.value}
          active={item.value === activeValue}
          isEditable={isEditable}
          onChange={onChange}
          tab={item}
          tabClassName={tabClassName}
        />
      ))}
      {isAddable && <AddTab onClick={onAddClick} tabText={addTabText} />}
    </div>
  );
};
